'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoWoman = function IoWoman(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm14.8 11.6c0.3-0.9 1.4-2.5 3.3-2.6h3.8c1.9 0.1 2.9 1.7 3.3 2.6l2.2 8.2c0.5 1.8-1.6 2.5-2.1 0.7l-2-7.5h-0.7l3.6 13.3h-3.4v9.9c0 1.8-2.4 1.8-2.4 0v-9.9h-0.8v9.9c0 1.8-2.5 1.8-2.5 0v-9.9h-3.3l3.5-13.3h-0.5l-2.1 7.5c-0.6 1.7-2.6 1.1-2.1-0.7z m8.1-6.2c0 1.6-1.3 2.9-2.9 2.9s-2.9-1.3-2.9-2.9 1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9z' })
        )
    );
};

exports.default = IoWoman;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/woman.js
// module id = 2559
// module chunks = 0